export enum SocialProfileTypeEnum {
    Facebook = 0,
    Twitter = 1,
    Instagram = 2,
    Weibo = 3,
    Wechat = 4,
    Other = 5,
    Linkedin = 6,
}